import Vue from 'vue'
import Toast from 'vue-toastification'

Vue.use(Toast, {
  timeout: 5000,
  hideProgressBar: true,
  transition: 'Vue-Toastification__fade',
  containerClassName: 'p-v-toast'
})
